import { render, staticRenderFns } from "./EvrakGonderView.vue?vue&type=template&id=47f8543a"
import script from "./EvrakGonderView.vue?vue&type=script&lang=ts"
export * from "./EvrakGonderView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports